import React from "react"
import { useHistory } from "react-router-dom"
import { useRecoilValue, useResetRecoilState } from "recoil"
import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"
import { Auth } from "aws-amplify"
import { makeStyles } from "@material-ui/core/styles"
import MuiAvatar from "@material-ui/core/Avatar"
import IconButton from "@material-ui/core/IconButton"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import Typography from "@material-ui/core/Typography"

const useStyles = makeStyles((theme) => ({
  info: {
    background: theme.palette.text.disabled,
    color: theme.palette.background.paper,
    fontSize: "0.85rem",
    marginBottom: theme.spacing(1),
    marginTop: -theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
}))

const Avatar = ({ logo, fullWidth, title }) => {
  const classes = useStyles()
  const history = useHistory()
  const [profileOpen, setProfileOpen] = React.useState(null)
  const user = useRecoilValue(currentUser)
  const resetAssociation = useResetRecoilState(currentAssociation)
  const resetUser = useResetRecoilState(currentUser)

  async function handleLogout() {
    await Auth.signOut()
    resetAssociation()
    resetUser()
    history.push("/signin")
  }

  const handleClick = (event) => {
    setProfileOpen(event.currentTarget)
  }

  const handleClose = () => {
    setProfileOpen(null)
  }

  return (
    <>
      {user.isLoggedIn ? (
        <div>
          <IconButton
            aria-label="open"
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MuiAvatar src="/broken-image.jpg" />
          </IconButton>
          <Menu
            anchorEl={profileOpen}
            keepMounted
            open={Boolean(profileOpen)}
            onClose={handleClose}
          >
            <Typography className={classes.info} component="li">
              <strong>
                {user.firstName} {user.lastName}
              </strong>
              <br />
              <strong>{user.email}</strong>
            </Typography>
            <MenuItem
              onClick={() => {
                history.push("/0/profile")
                handleClose()
              }}
            >
              Profile
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push("/0/associations")
                handleClose()
              }}
            >
              Manage Associations
            </MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      ) : (
        ""
      )}
    </>
  )
}

export default Avatar
